
import { Component, Vue, Ref } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { ElForm } from 'element-ui/types/form'
import { peopleTypes } from '@/constants/peopleTypes'

@Component({
    name: 'create-person-form'
})
export default class extends Vue {
    @Ref('personForm') private formEl!: ElForm
    private rules = {
        name: { required: true, message: '名字为必填项' },
        label: { required: true, message: '头衔为必填项' }
    }
    private peopleTypes = peopleTypes
    private personForm = {
        name: '',
        label: '',
        type_id: [],
        nationality: '',
        university: '',
        birthday: '',
        post: '',
        intro: '',
        check: '',
        status: ''
    }

    get industryList() {
        return AppModule.industry
    }

    private mounted() {
        AppModule.getIndustry()   
    }

    validate(fn: (form: any) => void) {
        this.formEl.validate((isValid => {
            if (!isValid) return
            fn && fn({
                ...this.personForm,
                type_id: this.personForm.type_id.pop(),
                post: this.personForm.post
            })
        }))
    }
}
